<mat-dialog-content>
    <form novalidate (keyup.enter)="columnForm.valid && save()" class="create-form form-container" [formGroup]="columnForm">
        <p-multiSelect placeholder="Search" #multiSelectRef class="multiselect" [options]="allFieldOptions" [(ngModel)]="selectedFieldOptions" appendTo="body" formControlName="columnSelect"
            [filter]="false" [autofocusFilter]="true">
         <ng-template pTemplate="header">
            <div class="custom-multiselect-header">
                <button
                    type="button"
                    class="close-button"
                    (click)="multiSelectRef.hide()"
                    aria-label="Close"
                >
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </ng-template>
        </p-multiSelect>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="flex justify-flex-end gap-20">
    <button mat-button (click)="dialogRef.close()" class="flex-20">Cancel</button>
    <button mat-button color="primary" (click)="save()" [disabled]="columnForm?.invalid" class="flex-20">Save</button>
</mat-dialog-actions>
